<template>
	<div @keydown.esc="DeselectImages">
		<confirm ref="confirm"></confirm>
		<vue-headful v-if="eventDetails" :title="eventDetails.Name" :description="$t('pageMetaDescription')" />
		<v-breadcrumbs :items="breadcrumbsItems">
      <template v-slot:divider>
			<v-icon class="secondary--text text--lighten-2">fas fa-caret-right</v-icon>
      </template>
		</v-breadcrumbs>

		<v-toolbar color="rounded" v-if="eventDetails">
			<v-toolbar-items v-if="selectedFilesCount">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon @click="SelectAll(false)" v-bind="attrs" v-on="on">
							<v-icon>fas fa-times-circle</v-icon>
						</v-btn>
					</template>
					<span>{{ $t("unselectFiles") }}</span>
				</v-tooltip>
			</v-toolbar-items>
			<v-toolbar-items v-else>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon @click="SelectAll(true)" v-bind="attrs" v-on="on">
							<v-icon>fas fa-check-circle</v-icon>
						</v-btn>
					</template>
					<span>{{ $t("selectAll") }}</span>
				</v-tooltip>
			</v-toolbar-items>
			<v-toolbar-title v-if="!selectedFilesCount">{{ eventDetails.Name }}
			</v-toolbar-title>
			<v-toolbar-title v-else>
				{{ selectedFilesCount }}
				{{ selectedFilesCount === 1 ? $t("fileSelected") : $t("filesSelected") }}
			</v-toolbar-title>

			<v-spacer></v-spacer>
			<v-toolbar-items>
				<template v-if="!selectedFilesCount">

					<v-tooltip bottom v-if="!SortMode">
						<template v-slot:activator="{ on, attrs }">
							<v-btn icon @click="StartSort"  v-bind="attrs" v-on="on">
								<v-icon>far fa-sort</v-icon>
							</v-btn>
						</template>
						<span>Ordina le foto</span>
					</v-tooltip>
					<template v-else>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon @click="EndSort" v-bind="attrs" v-on="on">
									<v-icon left>far fa-times</v-icon>
								</v-btn>
							</template>
							<span>{{ $t("common.cancel") }}</span>
						</v-tooltip>

						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon @click="SaveSortOrder" v-bind="attrs" v-on="on">
									<v-icon left>far fa-save</v-icon>
								</v-btn>
							</template>
							<span>{{ $t("common.save") }}</span>
						</v-tooltip>

						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon @click="ResetSortOrder" v-bind="attrs" v-on="on">
									<v-icon left>fas fa-sort-alpha-down</v-icon>
								</v-btn>
							</template>
							<span>Ordina per nome</span>
						</v-tooltip>
					</template>

					<template v-if="!SortMode">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon @click="CopyPortfolioLink" v-bind="attrs" v-on="on">
									<v-icon>fas fa-copy</v-icon>
								</v-btn>
							</template>
							<span>Copia link portfolio</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon @click="pickFile" v-bind="attrs" v-on="on">
									<v-icon>fas fa-upload</v-icon>
								</v-btn>
							</template>
							<span>{{ $t("common.uploadTooltip") }}</span>
						</v-tooltip>

						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon @click="LoadStorageFolderFiles" v-bind="attrs" v-on="on">
									<v-icon>fas fa-sync-alt</v-icon>
								</v-btn>
							</template>
							<span>{{ $t("common.refreshData") }}</span>
						</v-tooltip>

<!--						<v-tooltip bottom>-->
<!--							<template v-slot:activator="{ on, attrs }">-->
<!--								<v-btn icon @click="SwitchView" :color="flatFilesView ? '' : 'info'" v-bind="attrs"-->
<!--									v-on="on">-->
<!--									<v-icon>fas fa-folder-tree</v-icon>-->
<!--								</v-btn>-->
<!--							</template>-->
<!--							<span>{{-->
<!--								flatFilesView ? $t("enableFolderView") : $t("enableFlatFilesView")-->
<!--								}}</span>-->
<!--						</v-tooltip>-->
					</template>

				</template>

				<template v-else>
					<v-btn @click="ShowCopyrightUpdateDialog" icon>
						<v-icon>fas fa-copyright</v-icon>
					</v-btn>

					<v-btn icon @click=" DeleteSelectedImages">
						<v-icon>fas fa-trash</v-icon>
					</v-btn>

				</template>
			</v-toolbar-items>

			<div slot="extension" v-if="!flatFilesView" class="">
				<FolderViewNavigation :Path="currentSubFolder" @navigate-to="navigateToSubFolder($event)">
				</FolderViewNavigation>
			</div>
		</v-toolbar>
		<div style="display: none">
			<v-file-input multiple @change="fileUploadSelected" v-model="uploadFiles" ref="inputFiles"></v-file-input>
		</div>

		<v-progress-linear indeterminate v-if="LoadingImages"> </v-progress-linear>
		<v-container
			v-if="!SortMode"
			@drop.stop.prevent="dropFile" @dragover.prevent="dragOverHandler" @dragenter="setDragOverlay"
			@dragleave="setDragOverlay">
			<v-overlay v-if="dragOverlay" :absolute="false" opacity="0.6">
				<!-- <v-progress-circular indeterminate size="64"></v-progress-circular> -->
				<v-icon size="120" color="grey">fas fa-upload</v-icon>
			</v-overlay>

			<FileUploadQueue :uploadQueue="uploadQueue" :currentSubFolder="currentSubFolder" :EventId="EventId"
				@fileUploaded="OnFileUploaded"></FileUploadQueue>
			<v-row>
				<v-col class="pa-1" v-if="!LoadingImages && Files.length === 0">
					<v-alert dark class="info"> Nessun file in evento </v-alert>
				</v-col>
			</v-row>

			<PhotoGrid :Files="Files" class="mt-5 mx-1" :targetHeight="200">
				<template v-slot:cell="{ file, index }">
					<v-responsive aspect-ratio="1.2" class="rounded elevation-3 pointer" v-if="file.IsDirectory"
						@click="setWorkingSubFolder(file)">
						<v-row class="fill-height ma-0" align="center" justify="center">
							<div class="text-center">
								<v-icon size="60" color="yellow darken-2">fas fa-folder </v-icon>
								<br />

								{{ file.DisplayName }}
							</div>
						</v-row>
					</v-responsive>
					<template v-else>
						<SelectableItem v-if="file.Metadata" v-model="file.Selected"
							@selectClick="onItemSelected($event, index)"
							@unselectClick="onItemUnselected($event, index)" @zoomClick="ShowImageDialog(file, index)">
							<!-- @click="" -->
							<AzurePreviewImage v-if="file.Metadata.PreviewFile" :file="file" class="darkened-image">
							</AzurePreviewImage>

						</SelectableItem>

					</template>
				</template>
			</PhotoGrid>
		</v-container>
		<v-container v-if="SortMode">
			<draggable v-model="Files" @end="DragItemEnd" @start="DragItemStart"
					v-bind="{ animation: 450 }" tag="div"	class="d-flex flex-wrap" style="gap:5px;">
				<div v-for="(file, index) in Files" :key="file.id" class="mb-2">
					<v-img
						:src="file.Metadata.ThumbnailUrl + SasToken"
						:alt="file.DisplayName"
						contain
						height="150"
						width="200"
					>
						<span v-if="0">i:{{index+1}} / m:{{file.Metadata.SortOrder}}</span>
					</v-img>
				</div>
			</draggable>
		</v-container>

		<eventDetailsDialog v-model="showImageDialog" :EventId="EventId" :SgpEventsService="SgpEventsService"
			v-bind:carouselCurrentIndex="carouselCurrentIndex" @carousel-current-index-changed="OnCarouselIndexChanged"
			:Files="Files"></eventDetailsDialog>

		<UpdateCopyrightDialog v-model="copyrightDialog.showUpdateCopyrightDialog" @ExifUpdated="ExifUpdated"
			:EventId="EventId" :SelectedFiles="SelectedFiles"></UpdateCopyrightDialog>
	</div>
</template>
<script>
import CrudClient from "@/services/CrudClient/";
import { mapActions, mapGetters } from "vuex";

import eventDetailsDialog from "../EventDetailsImageDialog.vue";
import Confirm from "@/components/Shared/Common/Confirm";
import SelectableItem from "@/components/Shared/Common/SelectableItemV2.vue";
import AzurePreviewImage from "@/components/Shared/UI/AzurePreviewImage.vue";
import UpdateCopyrightDialog from "../components/UpdateCopyrightDialog";
import FileUploadQueue from "../components/FileUploadQueue.vue";

import FolderViewNavigation from "@/components/Shared/UI/FolderViewNavigation.vue";

import PhotoGrid from "@/components/Shared/UI/PhotoGrid";

import { QueueStatus } from "../components/queueStatusEnum.js";
import draggable from "vuedraggable";

export default {
	name: "EventDetails",
	components: {
		eventDetailsDialog,
		Confirm,
		SelectableItem,
		PhotoGrid,
		AzurePreviewImage,
		FolderViewNavigation,
		FileUploadQueue,
		UpdateCopyrightDialog,
		draggable
	},
	data() {
		return {
			breadcrumbsItems: [
				{
					text: "Home",
					disabled: false,
					exact: true,
					to: "/",
				},
			],
			eventDetails: null,
			LoadingImages: false,

			flatFilesView: false,
			currentSubFolder: null,
			Files: [],
			lastSelectedFileIndex: null,

			showImageDialog: false,

			uploadFiles: [], // binded to file-input control
			uploadQueue: [], // file-input files are added to the queue

			carouselCurrentIndex: null,

			dragOverlay: 0,

			GridView: [],
			copyrightDialog: { showUpdateCopyrightDialog: false },
			SortMode: false
		};
	},
	computed: {
		...mapGetters([
			"isUserInRole", "SasToken"
		]),
		EventId() {
			return parseInt(this.$route.params.EventId);
		},

		selectedFilesCount() {
			return this.Files.filter((f) => f.Selected).length;
		},

		SelectedFiles() {
			return this.Files.filter((f) => f.Selected);
		}
	},
	created() {
		this.SgpEventsService = new CrudClient("SGP/Events");
		this.SgpPortfolioEventsService = new CrudClient("SGP/PortfolioEvents");
		this.QueueStatus = QueueStatus;
	},
	async mounted() {
		this.eventDetails = await this.SgpEventsService.Get(this.EventId);

		this.breadcrumbsItems.push({
			text: this.$t("sgp.portfolio"),
			disabled: false,
			exact: true,
			to: "/PortfolioEvents",
		});
		this.breadcrumbsItems.push({
			text: this.eventDetails.Name,
			disabled: true,
			exact: true,
			to: "/PortfolioEvents/" + this.EventId,
		});

		await this.LoadStorageFolderFiles();
	},
	methods: {
		...mapActions(["snackSuccess", "snackError"]),

		onItemSelected(event, index) {
			this.$log.debug("input: " + index);

			if (
				this.lastSelectedFileIndex != null &&
				this.lastSelectedFileIndex !== index
			) {
				if (event.shiftKey) {
					const start =
						this.lastSelectedFileIndex < index ? this.lastSelectedFileIndex : index;
					const end =
						this.lastSelectedFileIndex > index ? this.lastSelectedFileIndex : index;

					for (let i = start; i < end; i++) {
						this.Files[i].Selected = true;
					}
				}
			}
			this.lastSelectedFileIndex = index;
		},

		onItemUnselected() {
			this.lastSelectedFileIndex = null;
		},

		dragOverHandler(e) {
			e.dataTransfer.dropEffect = "move";
		},

		setDragOverlay(e) {
			if (e.type === "dragenter") {
				this.dragOverlay++;
			}
			if (e.type === "dragleave") {
				this.dragOverlay--;
			}
		},

		async dropFile(e) {
			this.dragOverlay = 0;
			// if (this.uploadingFiles) {
			// 	return;
			// }

			const droppedFiles = [...e.dataTransfer.files];
			if (!droppedFiles) return;

			// this.checkFileSize(droppedFiles);

			droppedFiles.forEach((element) => {
				element.url = window.URL.createObjectURL(element);
				element.uploadStatus = this.QueueStatus.QUEUED;

				this.uploadQueue.push(element);
			});

			// await this.UploadFilesFromQueue();
		},

		OnFileUploaded(file) {
			this.Files.push(file);
		},

		ShowImageDialog(file, index) {
			this.$log.debug(file);
			this.$log.debug(index);

			this.showImageDialog = true;
			this.carouselCurrentIndex = index;
		},
		StartSort() {
			this.SortMode = true;
		},
		EndSort() {
			this.SortMode = false;
		},

		async SaveSortOrder() {
			const CustomSortOrderRequestItems = this.Files

				.map((f, index) => ({ File: f, SortOrder: index + 1 }))
				.filter((f) => Number.parseInt(f.File.Metadata.SortOrder) !== (f.SortOrder))
				.map((f) => ({ Path: f.File.Path, SortOrder: f.SortOrder }));

			try {
				this.LoadingImages = true;
				await this.SgpPortfolioEventsService.Post(this.EventId,
					CustomSortOrderRequestItems,
					"Files/UpdateSortOrder",
					false
				);
			} catch (error) {
				this.snackError({ Text: this.$t("snackError_CannotLoadData") });
				this.$captureError(error);
			} finally {
				this.LoadingImages = false;
			}

			await this.LoadStorageFolderFiles();
			// this.SortMode = false;
		},

		async ResetSortOrder() {
			if (
				!(await this.$refs.confirm.open(
					this.$t("SortItems"),
					this.$t("confirmSortByFileName")
				))
			) {
				return;
			}

			try {
				this.LoadingImages = true;
				await this.SgpPortfolioEventsService.Post(
					this.EventId,
					null,
					"Files/ResetSortOrder",
					false
				);
			} catch (e) {
				this.snackError({ Text: this.$t("snackError_CannotLoadData") });
				this.$captureError(e);
			} finally {
				this.LoadingImages = false;
			}

			await this.LoadStorageFolderFiles();
		},

		DragItemStart() {},
		DragItemEnd() {},

		// async SwitchView() {
		// 	if (this.LoadingImages) return;
		// 	this.flatFilesView = !this.flatFilesView;
		// 	this.currentSubFolder = null;
		//
		// 	await this.LoadStorageFolderFiles();
		// },

		async navigateToSubFolder(path) {
			if (this.LoadingImages) return;
			this.currentSubFolder = path;

			await this.LoadStorageFolderFiles();
		},

		async setWorkingSubFolder(file) {
			if (this.LoadingImages) return;
			if (file) {
				if (!this.currentSubFolder) this.currentSubFolder = "";

				this.currentSubFolder += file.DisplayName + "/";
			} else {
				this.currentSubFolder = null;
			}

			await this.LoadStorageFolderFiles();
		},

		async LoadStorageFolderFiles() {
			this.LoadingImages = true;
			try {
				let parameters = "flatView=" + this.flatFilesView;
				if (this.currentSubFolder) {
					parameters += "&subFolder=" + encodeURIComponent(this.currentSubFolder);
				}

				const orderBy = "CustomSortOrder";
				parameters += "&orderBy=" + orderBy;
				parameters += "&addSasToken=false";

				const res = await this.SgpPortfolioEventsService.Get(
					this.EventId,
					"Files?" + parameters
				);

				this.lastSelectedFileIndex = null;
				res.forEach((f) => (f.Selected = false));

				this.Files = res;
			} catch (error) {
				this.snackError({ Text: this.$t("snackError_CannotLoadData") });
				this.$captureError(error);
			} finally {
				this.LoadingImages = false;
			}
		},

		CopyPortfolioLink() {
			const link = `https://sgpix.sgpitalia.com/Portfolio/${this.EventId}`;
			navigator.clipboard.writeText(link).then(() => {
				this.snackSuccess({ Text: this.$t("snackSuccess_LinkCopied") });
			}).catch(() => {
				this.snackError({ Text: this.$t("snackError_CopyFailed") });
			});
		},

		SelectAll(val) {
			this.Files.filter((f) => !f.IsDirectory).forEach((f) => (f.Selected = val));
		},

		async DeleteSelectedImages() {
			if (
				!(await this.$refs.confirm.open(
					this.$t("common.delete"),
					this.$t("common.confirmDelete")
				))
			) {
				return;
			}

			const selectedFiles = this.Files.filter((f) => f.Selected).map(
				(f) => f.Path
			);

			this.LoadingImages = true;
			try {
				await this.SgpEventsService.Post(
					this.EventId,
					selectedFiles,
					"DeleteFiles",
					false
				);

				// reactively remove selected images
				selectedFiles.forEach((selectedFile) => {
					this.Files.splice(
						this.Files.findIndex((f) => f.Path === selectedFile),
						1
					);
				});
			} catch (error) {
				this.snackError("common.error.cannotDelete");
				this.$captureError(error);
			} finally {
				this.LoadingImages = false;
			}
		},

		pickFile() {
			this.$refs.inputFiles.$refs.input.click();
		},

		async fileUploadSelected() {
			this.$log.debug(this.uploadFiles);
			for (const file of this.uploadFiles) {
				file.url = window.URL.createObjectURL(file);
				file.uploadStatus = this.QueueStatus.QUEUED;
				this.uploadQueue.push(file);
			}
			this.uploadFiles = [];

			// await this.UploadFilesFromQueue();
			// this.$log.debug("UploadFilesFromQueue ended");
		},

		OnCarouselIndexChanged(index) {
			this.carouselCurrentIndex = index;
		},

		ExifUpdated(item) {
			this.Files.find((f) => f.Path === item.Path).Metadata = item.Metadata;
		},

		ShowCopyrightUpdateDialog() {
			this.copyrightDialog.showUpdateCopyrightDialog = true;
		}
	},
};
</script>

<style lang="scss" scoped>
.darkened-image {
	filter: brightness(100%);
	transition: 0.3s;

	&:hover {
		filter: brightness(80%);
	}
}
</style>
<i18n>
{
	"it":{
		"fileSelected": "file selezionato",
		"filesSelected": "file selezionati",
		"unselectFiles": "Deseleziona i file",
		"eventOffersTooltip": "Proposte dell'evento",
		"eventOrdersTooltip": "Ordini dell'evento",
		"selectAll": "Seleziona tutti i file",
		"enableFolderView":"Abilita vista cartelle",
		"enableFlatFilesView":"Visualizza tutte le foto",
		"snackSuccess_LinkCopied": "Link copiato negli appunti",
		"snackError_CopyFailed": "Errore durante la copia del link",
		"SortItems": "Sei sicuro?",
		"confirmSortByFileName": "Stai per ordinare tutti i file in base al nome. L’ordinamento precedente verrà perso."
	}
}
</i18n>
